module.exports = __webpack_public_path__ + "img/watermark3x.22dcc041.png";